
<div class="pa-2" v-if="mail">
    <div class="v-flex mr-3 mt-3 ml-12">
        <p-inc-toolbar-button
            icon    = "mdi-file-document-outline"
            :label  = "$t('mail.templates.label')"
            :height = "900"
            ref     = "templateMenu"
        >
            <template v-slot:content>
                <p-inc-template-list
                    :index    = "mail.index"
                    :step     = "mail.step"
                    @template = "onTemplate"
                />
            </template>
        </p-inc-toolbar-button>

        <p-inc-toolbar-button
            icon    = "mdi-attachment"
            :label  = "$t('mail.attachments.label')"
            :height = "900"
        >
            <template v-slot:content="{ open }">
                <p-inc-attachments
                    :incident           = "incident"
                    :step               = "step"
                    :open               = "open"
                    :selected-documents = "selectedDocs"
                    @selected           = "onSelected"
                />
            </template>
        </p-inc-toolbar-button>

        <p-inc-toolbar-button
            icon    = "mdi-clipboard-file-outline"
            :label  = "$t('mail.assessment.label')"
            :height = "900"
        >
            <template v-slot:content>
                <p-inc-unit-documents
                    :unit               = "unit"
                    :units              = "units"
                    type                = "ASSESSMENT"
                    :selected-documents = "selectedDocs"
                    @selected           = "onSelected"
                />
            </template>
        </p-inc-toolbar-button>

        <p-inc-toolbar-button
            icon    = "mdi-file-cog-outline"
            :label  = "$t('mail.maintenance.label')"
            :height = "900"
        >
            <template v-slot:content>
                <p-inc-unit-documents
                    :unit               = "unit"
                    :units              = "units"
                    type                = "MAINTENANCE"
                    :selected-documents = "selectedDocs"
                    @selected           = "onSelected"
                />
            </template>
        </p-inc-toolbar-button>

        <v-btn
            class  = "dialog-button"
            color  = "primary"
            @click = "onSend"
            depressed
            style="height: 40px!important; margin-top: -6px;"
        >
            <div style="display: block">
                <div>
                    <v-icon color="white" size="22">mdi-email-outline</v-icon>
                </div>
                <div class="white--text button-label">{{ $t('mail.send') }}</div>
            </div>
        </v-btn>
    </div>

    <div class="ma-2 mb-1" >
        <div class="white pa-3 pt-2 pb-6">
            <v-row class="no-frame">
                <p-inc-mail-recipient
                    v-model     = "data.to"
                    :label      = "$t('mail.to')"
                    :recipients = "mail.to"
                    chip-color  = "primary"
                />
            </v-row>
            <v-row class="no-frame mt-1">
                <p-inc-mail-recipient
                    v-model     = "data.cc"
                    :label      = "$t('mail.cc')"
                    :recipients = "mail.cc"
                />
            </v-row>
            <v-row class="no-frame mt-1">
                <v-text-field
                    v-model = "data.subject"
                    class   = "mail-adress"
                    hide-details
                >
                    <template v-slot:prepend-inner>
                        <div class = "mail-label  mr-2">
                            {{ $t('mail.subject') }}
                        </div>
                    </template>
                </v-text-field>
            </v-row>
        </div>

    </div>

    <div class="white pa-4 pb-0" style="height: 470px">
        <vue-editor
            v-model         = "data.content"
            :editor-toolbar = "customToolbar"
            style="min-height: 400px; max-height: 400px; height: 400px;"
        />
    </div>

    <div class="pl-4 mail-attachments">
        <div class="mail-attachment-list" :key = "refresh" >
            <div v-for="(document, index) in selectedDocs" :key = "index" style="width: calc(50% - 4px); margin-bottom: 3px;">
                <p-inc-selectable-document
                    class="background-aliceblue"
                    :document = "document"
                    :selected = "isSelected(document)"
                    @selected = "onSelected"
                />
            </div>
        </div>
    </div>
</div>
